const FormatosGuias = (props) => {

    const downloadDocumento = (nombreDoc, baseDoc) => {
        const downloadLink = document.createElement("a")
        downloadLink.href = baseDoc
        downloadLink.download = nombreDoc
        downloadLink.click()
    }

    /*const downloadDocumentoMobile = (nombreDoc, baseDoc) => {
        const downloadLink = document.createElement("a");
        downloadLink.href = "data:application/octet-stream;base64," + baseDoc.split(",")[1]
        downloadLink.download = nombreDoc
        downloadLink.click()   
    }*/

    const downloadDocumentoMobile = (nombreDoc, baseDoc) => {
        const base64String = baseDoc.split(',')[1] // Replace with your actual Base64 string
        const byteCharacters = atob(base64String)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers);
        const fileBlob = new Blob([byteArray], { type: 'application/pdf' })
        const fileUrl = URL.createObjectURL(fileBlob)
        const link = document.createElement('a')
        link.href = fileUrl
        link.download = nombreDoc // Replace with the desired filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)        
        //window.open(fileUrl);
        URL.revokeObjectURL(fileUrl);
    }

    return (
        <>
            <div className="homeout__coberturas" style={{ backgroundColor: '#F7F7F7' }}>
                
                <p className="titulo__guias d-block d-lg-none" style={{'fontSize':'20px'}}><b>Descargables</b></p>
                <p className="titulo__guias d-none d-lg-block"><b>Encuentra aquí todos los formatos y guías para descargar</b></p>

                {/*MOBILE*/}
                <div className="d-block d-lg-none">
                    <div className="div__botones">
                        <button className="btn__azul" onClick={() => downloadDocumentoMobile("Formato Reclamación.pdf", props.pdfReclamacion)}>FORMATO DE RECLAMACIÓN</button>
                        <button className="btn__azul" onClick={() => downloadDocumentoMobile("Condiciones generales.pdf", props.pdfGuiaRapida)}>CONDICIONES GENERALES</button>
                        <button className="btn__azul" onClick={() => downloadDocumentoMobile("Derechos del asegurado.pdf", props.pdfDerechos)}>DERECHOS DEL ASEGURADO</button>
                    </div>
                </div>

                {/*DESKTOP*/}
                <div className="d-none d-lg-block">
                    <div className="div__botones">
                        <button className="btn__azul mx-5" onClick={() => downloadDocumento("Formato Reclamación.pdf", props.pdfReclamacion)}>FORMATO DE RECLAMACIÓN</button>
                        <button className="btn__azul mx-5" onClick={() => downloadDocumento("Derechos del asegurado.pdf", props.pdfDerechos)}>DERECHOS DEL ASEGURADO</button>
                        <button className="btn__azul mx-5" onClick={() => downloadDocumento("Condiciones generales.pdf", props.pdfGuiaRapida)}>CONDICIONES GENERALES</button>
                    </div>
                </div>
                
            </div>
        </>
    )
}

export default FormatosGuias